import { render, staticRenderFns } from "./blinds.vue?vue&type=template&id=f8f17664"
import script from "./blinds.ts?vue&type=script&lang=js&external"
export * from "./blinds.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports